export default __webpack_public_path__ + "media/images/users/user-sam-cromstain-370x370-299843bf48656ec87f3a77d8c0819d9b.jpg";